import classNames from 'classnames';
import { ROUTES } from '@/constants';
import type { ProductCatalog } from '@/interfaces/strapi';
import { generatePath, Link } from 'react-router-dom';

type CatalogProductListItemProps = {
	readonly className?: string;
	readonly product: ProductCatalog;
};

const classNameComponent = 'c-cnm-catalog-product-card';

export const CatalogProductListItem = ({ className, product }: CatalogProductListItemProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	return (
		<article className={wrapperClassName}>
			<Link
				to={generatePath(ROUTES.ACADEMIA_MATRITENSE_CATALOGO_BY_PRODUCT, {
					category: product.category.slug,
					product: product.slug,
				})}
				className={`${classNameComponent}__link`}
			>
				<div className={`${classNameComponent}__image`}>
					<img src={product.image.url} alt={product.image.alt} />
				</div>
				<div className={`${classNameComponent}__body`}>
					<h4 className={`${classNameComponent}__title`}>{product.name}</h4>
					<p className={`${classNameComponent}__author`}>{product.author}</p>
					<p className={`${classNameComponent}__price`}>{product.price.toFixed(2)} €</p>
				</div>
			</Link>
		</article>
	);
};
